import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Data2Service } from '../../common/data2.service';

@Component({
	selector: 'app-definitions-tags-leads',
	templateUrl: './definitions-tags-leads.component.html',
	styleUrls: ['./definitions-tags-leads.component.css'],
})
export class DefinitionsTagsLeadsComponent implements OnInit {
	private loader = false;
	tags: Array<any> = [];
	tagRemove: string;
	tagAdd = {
		id: null,
		group: null,
	};
	addError: string;

	constructor(
		private readonly api: Data2Service,
		private readonly router: Router,
	) {}

	ngOnInit(): void {
		this.loadData();
	}

	private loadData() {
		this.api.get('/definitions/tagsLeads', (result, error) => {
			this.tags = result.data;
		});
	}

	deleteAsk(tag: string): void {
		this.tagRemove = tag;
		const element = document.getElementById('askModalDelete');
		element.style.display = 'block';
		element.style.paddingRight = '17px';
		element.className = 'modal fade show';
	}

	deleteConfirm() {
		this.deleteClose();
		if (!this.tagRemove) {
			return;
		}
		this.api.del('/definitions/tagsLeads/' + this.tagRemove + '/', (result, error) => {
			this.afterSend(result, error);
		});
	}

	deleteClose() {
		const element = document.getElementById('askModalDelete');
		element.style.display = 'none';
		element.className = 'modal fade';
	}

	addAsk(): void {
		const element = document.getElementById('askModalAdd');
		element.style.display = 'block';
		element.style.paddingRight = '17px';
		element.className = 'modal fade show';
	}

	addConfirm() {
		this.addClose();
		if (!this.tagAdd.id || !this.tagAdd.group) {
			return;
		}
		this.api.post('/definitions/tagsLeads/', this.tagAdd, (result, error) => {
			this.afterSend(result, error);
		});
	}

	addClose() {
		const element = document.getElementById('askModalAdd');
		element.style.display = 'none';
		element.className = 'modal fade';
	}

	private afterSend(result, error) {
		this.loader = false;
		if (error) {
			return;
		}
		this.loadData();
	}
}
